import { create } from 'zustand';
import type { MessageInstance } from '@k-ucap/shared';

interface MessageState {
  messages: MessageInstance[];
  addMessage: (message: MessageInstance) => void;
  setMessages: (messages: MessageInstance[]) => void;
}

export const useMessageStore = create<MessageState>((set) => ({
  messages: [],
  addMessage: (message) =>
    set((state) => ({
      messages: [message, ...state.messages].slice(0, 100),
    })),
  setMessages: (messages) => set({ messages }),
}));
